import { render } from "./UsuarioResumenForm.vue?vue&type=template&id=6b7c4a74&scoped=true"
import script from "./UsuarioResumenForm.vue?vue&type=script&lang=js"
export * from "./UsuarioResumenForm.vue?vue&type=script&lang=js"

import "./UsuarioResumenForm.vue?vue&type=style&index=0&id=6b7c4a74&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7c4a74"]])

export default __exports__